import { AgreementBUInterface, BusinessUnitInterface } from '../interfaces'

/**
 * Oficinas ORIGEN del contrato (`/Agreement/AgreementBU`, isSource=true).
 *
 * Las TIENDAS DESTINO permitidas NO salen de acá: viven en
 * `utils/destinationBusinessUnits.ts`, que las lee de AccountSiteBU y espeja la
 * regla que ApiCore aplica de verdad (ShipmentController.cs:396-419). Son dos
 * fuentes distintas a propósito; no unificarlas sin confirmar con backend.
 */

export const AGREEMENT_BU_ACTIVE_STATUS = 1

// Filtra AgreementBU usables (isSource, !isLocked, statusID activo) y las mapea
// a la BusinessUnit completa por buCode, deduplicando por buid. Pura/testeable.
export const resolveOriginBusinessUnits = (
  agreementBUs: AgreementBUInterface[],
  businessUnits: BusinessUnitInterface[]
): BusinessUnitInterface[] => {
  const usable = agreementBUs.filter(
    (a) =>
      a.isSource &&
      !a.isLocked &&
      (a.statusID === AGREEMENT_BU_ACTIVE_STATUS || a.statusID == null)
  )

  const resolved: BusinessUnitInterface[] = []
  const seen = new Set<number>()

  usable.forEach((a) => {
    const bu = businessUnits.find((b) => b.buCode === a.buCode)
    if (!bu) {
      console.warn(`AgreementBU buCode sin match en catálogo: ${a.buCode}`)
      return
    }
    if (seen.has(bu.buid)) return
    seen.add(bu.buid)
    resolved.push(bu)
  })

  return resolved
}
